module.exports = __webpack_public_path__ + "img/img49.ea8f947a.svg";